import { render, staticRenderFns } from "./DynamicPageEdit.vue?vue&type=template&id=320980f5&scoped=true&"
import script from "./DynamicPageEdit.vue?vue&type=script&lang=js&"
export * from "./DynamicPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320980f5",
  null
  
)

export default component.exports